function isSameDay(date1, date2) {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  )
}

function isYesterday(date1, date2) {
  const yesterday = new Date(date1)
  yesterday.setDate(date1.getDate() - 1)
  return isSameDay(yesterday, date2)
}

// Function to format the date based on year difference
function formatDate(messageTime) {
  const messageDate = new Date(messageTime);
  const currentDate = new Date();

  const isSameYear = messageDate.getFullYear() === currentDate.getFullYear();

  const options = {month: 'long', day: 'numeric'};
  if (!isSameYear) {
    options.year = 'numeric';
  }

  if (isSameDay(currentDate, messageDate)) {
    return 'Today'
  } else if (isYesterday(currentDate, messageDate)) {
    return 'Yesterday'
  }
  // Using Intl.DateTimeFormat for better flexibility
  return new Intl.DateTimeFormat('en-US', options).format(messageDate);
}

// Function to group messages by day in descending order (newest date first)
export function groupMessagesByDay(messages) {
  // Sort messages in descending order based on timestamp
  messages.sort((a, b) => b.time - a.time);

  const grouped = {};

  messages.forEach((message) => {
    const formattedDate = formatDate(message.time);

    if (!grouped[formattedDate]) {
      grouped[formattedDate] = [];
    }
    grouped[formattedDate].push(message);
  });

  // Reverse messages inside each date group to be in ascending order
  Object.keys(grouped).forEach((date) => {
    grouped[date].reverse();
  });

  return grouped;
}
